import { Flex } from 'onefaceui-react-components';
import styled from 'styled-components';

export const Container = styled(Flex)`
  width: 370px;
  padding: 12px 0;

  .address-text {
    color: var(--grey-600);
  }

  .phone-icon {
    width: 12px;
  }
  .size-item p,
  .size-item i {
    color: var(--grey-600);
  }

  .size-item i {
    font-size: 18px;
  }

  .loading-content {
    width: 380px;
    height: 100px;
  }

  .stop-status,
  .size {
    margin: 6px 0;
  }

  .routeMonitorRouteStatusIcon {
    width: 26px !important;
    height: 26px !important;
  }

  p {
    line-height: normal;
  }
`;

export const ModalFooter = styled(Flex)`
  border-top: solid var(--grey-300) 1px;
  padding: 0.4rem;
`;

export const StopStatus = styled(Flex)`
  position: relative;
  padding: 4px 6px;
  border-radius: 12px;

  img {
    position: relative;
    z-index: 2;
    width: 12px;
  }

  &.PENDING {
    background-color: var(--pending-stop);
    img {
      width: 9px;
    }
  }

  &.DELIVERED {
    background-color: var(--delivered-stop);
  }

  &.REDELIVERED {
    background-color: var(--redelivered-stop);
  }

  &.UNDELIVERED {
    background-color: var(--undelived-stop);
    img {
      width: 9px;
    }
  }

  &.CANCELED {
    background-color: var(--canceled-stop);
  }

  &.IN_PROGRESS {
    background-color: var(--in-progress-stop);
    img {
      width: 11px;
    }
  }

  &.PARTIALLY_DELIVERED {
    background-color: var(--partially-delivered);
  }

  .status-icon {
    width: 16px;
    height: 16px;
    background-color: #fff;
    border-radius: 50%;
  }
`;
